export const DEFAULT_POWER_BI_MAP_MAX_FEATURES = 10_000;
export const DEFAULT_ARCGIS_FEATURE_MAX_FEATURES = 2_000;
export const DEFAULT_ARCGIS_CACHE_MINUTES = 0;
